export default __webpack_public_path__ + "static/media/right-arrow.e16678d2.svg";